import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfAppCategoryChartAllTimeAverageAggregateRootMapper } from '../../../infrastructure/mappers/app-category-metrics/get-self-app-category-chart-all-time-average.aggregate-root.mapper';
import { GetSelfAppCategoryChartAllTimeAverageRequestDto } from '../../dtos/app-category-metrics/get-self-app-category-chart-all-time-average.request.dto';
import { GetSelfAppCategoryChartAllTimeAverageResponseDto } from '../../dtos/app-category-metrics/get-self-app-category-chart-all-time-average.response.dto';
import { GetSelfAppCategoryChartAllTimeAveragesQuery } from '../../queries/app-category-metrics/get-self-app-category-chart-all-time-average.query';

export class GetSelfAppCategoryChartAllTimeAverageController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetSelfAppCategoryChartAllTimeAveragesQuery,
    protected readonly mapper: GetSelfAppCategoryChartAllTimeAverageAggregateRootMapper
  ) {}

  async get(
    props: GetSelfAppCategoryChartAllTimeAverageRequestDto
  ): Promise<GetSelfAppCategoryChartAllTimeAverageResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `GetSelfAppCategoryChartAllTimeAverageController.get encountered an error ${error}`
      );
    }
  }
}
